import React, {Component, ReactElement, ReactNode} from 'react'
import NatAdminUserRepo from './repository/NatAdminUserRepo'
import {NatPostAdminUser, PostAdminUserParams} from './repository/NatPostAdminUser'
import {NatGetCondominiumGroup} from '../condominiumGroup/repository/NatGetCondominiumGroup'
import NatCondominiumGroupRepo from '../condominiumGroup/repository/NatCondominiumGroupRepo'
import {CondominiumInfo} from '../condominium/repository/NatGetCondominiumList'
import {ResidentUserInfo} from '../roomToResident/repository/NatGetRoomToResident'
import NatRidgeRepo from '../ridge/repository/NatRidgeRepo'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import NatOwnerCondominiumRepo from '../ownerCondominium/repository/NatOwnerCondominiumRepo'
import {
    AVAILABLE_OR_NOT,
    DO_OR_NOT,
    MESSAGE_TYPE,
    ROLE_FOR_ADMINISTRATOR,
    SELECT_CONDOMINIUM_TYPE,
    SELECT_USER_TYPE,
} from '../../../CodeMaster'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {Messages} from '../../../Messages'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink} from '../../../styledComponents/adminPage/Links'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import PPTextField from '../../../components/shared/forms/PPTextField'
import PPRadioGroup, {PPRadioItemProp} from '../../../components/shared/forms/PPRadioGroup'
import NatCondominiumGroupSelectComponent from '../common/NatCondominiumGroupSelectComponent'
import NatCondominiumSelectionComponent from '../common/admin/NatCondominiumSelectionComponent'
import NatResidentUserSelectionComponent from '../common/admin/NatResidentUserSelectionComponent'
import NatCondominiumRepo from '../condominium/repository/NatCondominiumRepo'
import PPInput from '../../../components/shared/forms/PPInput'
import styled from 'styled-components'
import {StyledDiv, StyledSpan} from '../../../styledComponents/StyledTypeDefinitions'
import {NatGetOwnerCondominium, RoomToResident} from '../ownerCondominium/repository/NatGetOwnerCondominium'
import PPDatePicker from '../../../components/shared/forms/PPDatePicker'
import {formatForDateInput, formatForDateInputFromDate} from '../../../formatters/formatDate'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {RowFlexContainer} from '../../../styledComponents/FlexComponents'
import PPErrorDisplayButton from '../../../components/shared/forms/PPErrorDisplayButton'
import {ConditionTableFixed} from '../../../styledComponents/adminPage/ConditionTable'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import moment from 'moment'
import {Box, TableBody, TableCell, TableRow} from '@mui/material';
import {Warning} from '../common/admin/NatAcceptedWarning'
import NatAdminCommonAcceptedWarningComponent from '../common/admin/NatAdminCommonAcceptedWarningComponent'
import {NatGetAzureADUser} from './repository/NatGetAzureADUser'
import {Location} from 'react-router-dom'
import {autoKanaOnUpdate} from '../../common/util/Natutil'

const KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID: string = 'loginUserCondominiumGroupId'


interface Props {
    CondominiumRepo: NatCondominiumRepo
    AdminUserRepo: NatAdminUserRepo
    CondominiumGroupRepo: NatCondominiumGroupRepo
    RidgeRepo: NatRidgeRepo
    RoomToResidentRepo: NatRoomToResidentRepo
    OwnerCondominiumRepo: NatOwnerCondominiumRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    eventEmitter: EventEmitterExAdmin
    location: Location

}

interface States {
    condominiumGroup: NatGetCondominiumGroup
    roleId: string
    loginId: string
    password: string
    passwordConfirm: string
    loginAvailability: string
    termStartDate: string
    termEndDate: string
    maxTermStartDate: string
    minTermEndDate: string
    condominiumCd: string
    sutekiNetId: string
    mailAddressValue: string
    familyNameValue: string
    firstNameValue: string
    familyNameKanaValue: string
    firstNameKanaValue: string
    adminUserListSearchCondition: []
    isLoadCompleted: boolean
    dialogOpenSelectCondominium: boolean
    dialogOpenSelectResidentUser: boolean
    selectedCondominiumInfo: CondominiumInfo
    selectedResidentUserInfo: ResidentUserInfo
    selectedResidentUsersRoomInfo: string
    selectedCondominiumGroupId: number | null
    loginUserCondominiumGroupId: number | null
    selectedRoomToResidentInfos: RoomToResident[]
    handoverCondominiumGroupId: Nullable<number>
    handoverCondominiumGroupName: Nullable<string>
    endDateOfHandover: Nullable<Date>
    setHandoverCondominiumGroup: Nullable<string>
    currentDate: Nullable<moment.Moment>
    warning: Warning[]
    warningChecked: boolean
    convertFamilyNameKana: string
    preFamilyNameKana: string
    convertFirstNameKana: string
    preFirstNameKana: string
}

class NatAdminAdminUserRegisterPage extends Component<Props & AdminPagePropsSet, States> {

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        const loginUserCondominiumGroupId: Nullable<number> =
            SessionStorageHelper.getNumberItemOrNull(KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID)

        this.state = {

            condominiumGroup: {
                ['details']: null,
                ['informations']: [],
                ['requestError']: null,
                ['requestItemErrors']: [],
            },
            roleId: ROLE_FOR_ADMINISTRATOR.SYSTEM_ADMIN.value,
            loginId: '',
            password: '',
            passwordConfirm: '',
            loginAvailability: '',
            termStartDate: '',
            termEndDate: '',
            maxTermStartDate: '',
            minTermEndDate: '',
            condominiumCd: '',
            sutekiNetId: '',
            mailAddressValue: '',
            familyNameValue: '',
            firstNameValue: '',
            familyNameKanaValue: '',
            firstNameKanaValue: '',
            adminUserListSearchCondition: [],
            isLoadCompleted: false,
            dialogOpenSelectCondominium: false,
            dialogOpenSelectResidentUser: false,
            selectedCondominiumInfo: {
                condominiumCd: '',
                condominiumName: '',
                condominiumGroupName: '',
                prefectureCd: '',
                address2: '',
                updateDatetime: '',
                releaseFlg: '',
            },
            selectedResidentUserInfo: {
                sutekiNetId: '',
                seq: 0,
                ridgeCd: '',
                ridgeName: '',
                roomNumber: '',
                familyName: '',
                firstName: '',
                adminFamilyName: '',
                adminFirstName: '',
                parentAdminFamilyName: '',
                parentAdminFirstName: '',
                roleName: '',
                mailAddressPc: '',
                mailAddressMb: '',
                parentFamilyName: '',
                parentFirstName: '',
                status: '',
                updateDatetime: '',
                condominiumGroupName: '',
                condominiumCd: '',
                condominiumName: '',
            },
            selectedResidentUsersRoomInfo: '',
            selectedCondominiumGroupId: loginUserCondominiumGroupId,
            loginUserCondominiumGroupId: loginUserCondominiumGroupId,
            selectedRoomToResidentInfos: [],
            handoverCondominiumGroupId: null,
            handoverCondominiumGroupName: null,
            endDateOfHandover: null,
            setHandoverCondominiumGroup: null,
            currentDate: null,
            warning: [],
            warningChecked: false,
            convertFamilyNameKana: '',
            preFamilyNameKana: '',
            convertFirstNameKana: '',
            preFirstNameKana: '',
        }

        this.handleOpenCondominiumSelectionDialog = this.handleOpenCondominiumSelectionDialog.bind(this)
        this.handleOpenResidentUserSelectionDialog = this.handleOpenResidentUserSelectionDialog.bind(this)
        this.closeSelectCondominiumDiaLog = this.closeSelectCondominiumDiaLog.bind(this)
        this.closeSelectResidentUserDiaLog = this.closeSelectResidentUserDiaLog.bind(this)
        this.renderSelectedCondominiumInfo = this.renderSelectedCondominiumInfo.bind(this)
        this.setSelectedCondominiumInfo = this.setSelectedCondominiumInfo.bind(this)
        this.setSelectedResidentUserInfo = this.setSelectedResidentUserInfo.bind(this)
        this.onChangeSelectedCondominiumGroupId = this.onChangeSelectedCondominiumGroupId.bind(this)
        this.onChangeTermStartDate = this.onChangeTermStartDate.bind(this)
        this.onChangeTermEndDate = this.onChangeTermEndDate.bind(this)
        this.onChangeLoginAvailability = this.onChangeLoginAvailability.bind(this)
        this.onChangeFamilyName = this.onChangeFamilyName.bind(this)
        this.onChangeFirstName = this.onChangeFirstName.bind(this)
        this.onChangeFamilyNameKana = this.onChangeFamilyNameKana.bind(this)
        this.onChangeFirstNameKana = this.onChangeFirstNameKana.bind(this)
        this.handleChangeLoginId = this.handleChangeLoginId.bind(this)
        this.handleChangeMailAddress = this.handleChangeMailAddress.bind(this)
        this.handleChangePassword = this.handleChangePassword.bind(this)
        this.handleChangePasswordConfirm = this.handleChangePasswordConfirm.bind(this)
        this.handleChangeSetHandoverCondominiumGroup = this.handleChangeSetHandoverCondominiumGroup.bind(this)
        this.handleChangeHandoverCondominiumGroupId = this.handleChangeHandoverCondominiumGroupId.bind(this)
        this.handleChangeEndDateOfHandover = this.handleChangeEndDateOfHandover.bind(this)
        this.changeAcceptedWarnings = this.changeAcceptedWarnings.bind(this)
        this.getAzureADUser = this.getAzureADUser.bind(this)
        this.onCompositionStartFamilyName = this.onCompositionStartFamilyName.bind(this)
        this.onCompositionUpdateFamilyName = this.onCompositionUpdateFamilyName.bind(this)
        this.onCompositionStartFirstName = this.onCompositionStartFirstName.bind(this)
        this.onCompositionUpdateFirstName = this.onCompositionUpdateFirstName.bind(this)
    }


    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 物件グループマスタ取得
            const condominiumGroupResponse: Nullable<NatGetCondominiumGroup> = await this.props.asyncCallFunction(
                this.props.CondominiumGroupRepo.getCondominiumGroup.bind(this.props.CondominiumGroupRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (condominiumGroupResponse && condominiumGroupResponse.details) {
                const currentDateTime: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
                    this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )
                if (currentDateTime && currentDateTime.details) {
                    this.setState({
                        condominiumGroup: condominiumGroupResponse,
                        currentDate: moment(currentDateTime.details.currentDateTime),
                    })

                    // 検索画面からの検索条件を引き継ぐ
                    if (this.props.location.state) {
                        if (this.props.location.state.searchCondition) {
                            this.setState({
                                adminUserListSearchCondition: this.props.location.state.searchCondition,
                            })
                        }
                    }
                }
            } else {
                this.props.navigate(
                    `/admin/error`,
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleRegisterOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()

        if (this.state.roleId === ROLE_FOR_ADMINISTRATOR.FRONT_STAFF.value &&
            !this.state.mailAddressValue &&
            !this.state.warningChecked) {
            this.setState({
                warning: [
                    {
                        messageId: Messages.WADMA0001.toStringWithId(),
                        message: Messages.WADMA0001.toString(),
                    },
                ],
            })
            return
        }

        await this.props.eventEmitter.showLoading()

        const registerAdminUserParams: PostAdminUserParams = {
            roleId: this.state.roleId,
            loginId: this.state.loginId,
            mailAddress: this.state.mailAddressValue,
            familyName: this.state.familyNameValue,
            firstName: this.state.firstNameValue,
            familyNameKana: this.state.familyNameKanaValue,
            firstNameKana: this.state.firstNameKanaValue,
            termStartDate: this.state.termStartDate,
            termEndDate: this.state.termEndDate,
            loginAvailability: this.state.loginAvailability,
            condominiumCd: this.state.selectedCondominiumInfo.condominiumCd,
            sutekiNetId: this.state.selectedResidentUserInfo.sutekiNetId,
            handoverCondominiumGroupId: this.state.handoverCondominiumGroupId,
            endDateOfHandoverPeriod: this.state.endDateOfHandover
                ? formatForDateInputFromDate(this.state.endDateOfHandover)
                : null,
        }

        if (this.state.selectedCondominiumGroupId) {
            registerAdminUserParams.condominiumGroupId = this.state.selectedCondominiumGroupId
        }

        if (this.state.password) {
            registerAdminUserParams.password = this.state.password
        }

        if (this.state.passwordConfirm) {
            registerAdminUserParams.passwordConfirm = this.state.passwordConfirm
        }

        if (this.state.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value) {
            registerAdminUserParams.familyName = null
            registerAdminUserParams.firstName = null
        }

        if (this.state.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value
            && !this.state.sutekiNetId) {
            registerAdminUserParams.ridgeCd = this.state.selectedResidentUserInfo.ridgeCd
            registerAdminUserParams.roomNumber = this.state.selectedResidentUserInfo.roomNumber
            registerAdminUserParams.seq = this.state.selectedResidentUserInfo.seq
        }

        try {
            const registerAdminUserResponse: Nullable<NatPostAdminUser> = await this.props.asyncCallFunction(
                this.props.AdminUserRepo.registerAdminUser.bind(this.props.AdminUserRepo, registerAdminUserParams),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
                {defaultErrorTitle: Messages.EOPCA0001.toString('管理者ユーザ')},
            )
            if (registerAdminUserResponse && registerAdminUserResponse.details) {
                this.props.navigate(
                    `/admin/adminUser/${registerAdminUserResponse.details.adminId}`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0007.toString('管理者ユーザ'),
                            },
                        },
                    },
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }

    }

    async getAzureADUser(): Promise<void> {
        const {loginId} = this.state
        await this.props.eventEmitter.showLoading()

        try {
            const response: Nullable<NatGetAzureADUser> = await this.props.asyncCallFunction(
                this.props.AdminUserRepo.getAzureADUser.bind(this.props.AdminUserRepo, loginId),
                async (httpErrorOrNetworkError) => {
                    const requestItemErrors = httpErrorOrNetworkError.responseBody.requestItemErrors
                    requestItemErrors.forEach((item) => {
                        this.props.eventEmitter.emit(item.resultCode, item)
                    })
                },
            )

            if (response && response.details) {
                this.setState({
                    mailAddressValue: response.details.mailAddress,
                    familyNameValue: response.details.familyName.substr(0, 10),
                    firstNameValue: response.details.firstName.substr(0, 10),
                    familyNameKanaValue: '',
                    firstNameKanaValue: '',
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    onChangeSelectedCondominiumGroupId(condomoniumGroupId: number): void {
        this.setState({selectedCondominiumGroupId: condomoniumGroupId})

        // 物件グループを変更する度に選択した物件・居住者を初期化する
        this.setState({
            selectedCondominiumInfo: {
                condominiumCd: '',
                condominiumName: '',
                condominiumGroupName: '',
                prefectureCd: '',
                address2: '',
                updateDatetime: '',
                releaseFlg: '',
            },
            selectedRoomToResidentInfos: [],
        })
    }

    // 登録ボタン押下
    async registerAdminUserButton(): Promise<void> {

        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0012.errorLevel,
                message: Messages.IOPCC0012.toString('管理者ユーザ'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick.bind(this),
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleRegisterOkClick.bind(this),
                    },
                ],
            },
        )
    }

    judgementDispPostAdminUserButton(): boolean {

        const {
            loginId,
            roleId,
            familyNameValue,
            firstNameValue,
            password,
            passwordConfirm,
            loginAvailability,
            selectedCondominiumInfo,
            selectedCondominiumGroupId,
            selectedRoomToResidentInfos,
            setHandoverCondominiumGroup,
            endDateOfHandover,
            warning,
            warningChecked,
        } = this.state

        // 全権限共通
        // 必須項目：[権限],[物件グループ],[管理者ID],[ログイン可否]
        if (roleId === ''
            || selectedCondominiumGroupId === null
            || loginId === ''
            || loginAvailability === '') {
            return true
        }

        // 管理組合役員以外
        // 必須項目：[氏名（姓）],[氏名（名）]
        if (roleId !== ROLE_FOR_ADMINISTRATOR.ASSOC.value) {
            if (familyNameValue === '' || firstNameValue === '') {
                return true
            }
        }

        // ライフマネージャ、コンシェルジュ、管理組合役員
        // 必須項目：[物件コード]
        if ((roleId === ROLE_FOR_ADMINISTRATOR.LIFE_MANAGER.value ||
                roleId === ROLE_FOR_ADMINISTRATOR.CONCIERGE.value ||
                roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value) &&
            (!selectedCondominiumInfo.condominiumCd ||
                !password ||
                !passwordConfirm)
        ) {
            return true
        }

        // 管理組合役員のみ
        // 必須項目：[居住者ユーザ]
        if (roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value) {
            if (selectedRoomToResidentInfos.length === 0) {
                return true
            }
        }

        if (roleId === ROLE_FOR_ADMINISTRATOR.FRONT_STAFF.value) {
            if (setHandoverCondominiumGroup === DO_OR_NOT.DO.value
                && !endDateOfHandover) {
                return true
            }
        }

        if (warning.length > 0 && !warningChecked) {
            return true
        }

        // 登録ボタンを表示させる
        return false
    }

    onChangeRole(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({roleId: event.target.value, warning: [], warningChecked: false})
        if (event.target.value === ROLE_FOR_ADMINISTRATOR.ASSOC.value) {
            this.setState({
                familyNameValue: '',
                firstNameValue: '',
                familyNameKanaValue: '',
                firstNameKanaValue: '',
                setHandoverCondominiumGroup: null,
                handoverCondominiumGroupId: null,
                handoverCondominiumGroupName: null,
                endDateOfHandover: null,
            })
        }
        if (event.target.value === ROLE_FOR_ADMINISTRATOR.LIFE_MANAGER.value ||
            event.target.value === ROLE_FOR_ADMINISTRATOR.CONCIERGE.value) {
            this.setState({
                selectedResidentUserInfo: {
                    sutekiNetId: '',
                    seq: 0,
                    ridgeCd: '',
                    ridgeName: '',
                    roomNumber: '',
                    familyName: '',
                    firstName: '',
                    adminFamilyName: '',
                    adminFirstName: '',
                    parentAdminFamilyName: '',
                    parentAdminFirstName: '',
                    roleName: '',
                    mailAddressPc: '',
                    mailAddressMb: '',
                    parentFamilyName: '',
                    parentFirstName: '',
                    status: '',
                    updateDatetime: '',
                    condominiumGroupName: '',
                    condominiumCd: '',
                    condominiumName: '',
                },
                selectedRoomToResidentInfos: [],
                setHandoverCondominiumGroup: null,
                handoverCondominiumGroupId: null,
                handoverCondominiumGroupName: null,
                endDateOfHandover: null,
            })
        }
        if (event.target.value === ROLE_FOR_ADMINISTRATOR.SYSTEM_ADMIN.value ||
            event.target.value === ROLE_FOR_ADMINISTRATOR.CALL_CENTER.value ||
            event.target.value === ROLE_FOR_ADMINISTRATOR.OFFICE_CENTER_OWNERSHIP_TRANSFER.value
        ) {
            this.setState({
                selectedResidentUserInfo: {
                    sutekiNetId: '',
                    seq: 0,
                    ridgeCd: '',
                    ridgeName: '',
                    roomNumber: '',
                    familyName: '',
                    firstName: '',
                    adminFamilyName: '',
                    adminFirstName: '',
                    roleName: '',
                    mailAddressPc: '',
                    mailAddressMb: '',
                    parentFamilyName: '',
                    parentFirstName: '',
                    parentAdminFamilyName: '',
                    parentAdminFirstName: '',
                    status: '',
                    updateDatetime: '',
                    condominiumGroupName: '',
                    condominiumCd: '',
                    condominiumName: '',
                },
                selectedCondominiumInfo: {
                    condominiumCd: '',
                    condominiumName: '',
                    condominiumGroupName: '',
                    prefectureCd: '',
                    address2: '',
                    updateDatetime: '',
                    releaseFlg: '',
                },
                selectedRoomToResidentInfos: [],
                setHandoverCondominiumGroup: null,
                handoverCondominiumGroupId: null,
                handoverCondominiumGroupName: null,
                endDateOfHandover: null,
            })
        }
        if (event.target.value === ROLE_FOR_ADMINISTRATOR.FRONT_STAFF.value) {
            this.setState({
                selectedResidentUserInfo: {
                    sutekiNetId: '',
                    seq: 0,
                    ridgeCd: '',
                    ridgeName: '',
                    roomNumber: '',
                    familyName: '',
                    firstName: '',
                    adminFamilyName: '',
                    adminFirstName: '',
                    roleName: '',
                    mailAddressPc: '',
                    mailAddressMb: '',
                    parentFamilyName: '',
                    parentFirstName: '',
                    parentAdminFamilyName: '',
                    parentAdminFirstName: '',
                    status: '',
                    updateDatetime: '',
                    condominiumGroupName: '',
                    condominiumCd: '',
                    condominiumName: '',
                },
                selectedCondominiumInfo: {
                    condominiumCd: '',
                    condominiumName: '',
                    condominiumGroupName: '',
                    prefectureCd: '',
                    address2: '',
                    updateDatetime: '',
                    releaseFlg: '',
                },
                selectedRoomToResidentInfos: [],
                setHandoverCondominiumGroup: DO_OR_NOT.NOT.value,
                handoverCondominiumGroupId: null,
                handoverCondominiumGroupName: null,
                endDateOfHandover: null,
            })
        }
    }

    async handleChangeSetHandoverCondominiumGroup(event: React.ChangeEvent<HTMLInputElement>): Promise<void> {
        const setHandoverCondominiumGroup = event.target.value
        if (setHandoverCondominiumGroup === DO_OR_NOT.DO.value) {

            const currentDate = this.state.currentDate!.clone()
            const defaultDate = new Date(currentDate!.add(2, 'month').endOf('month').format('YYYY-MM-DD'))
            this.setState({
                setHandoverCondominiumGroup: setHandoverCondominiumGroup,
                handoverCondominiumGroupId: this.state.loginUserCondominiumGroupId,
                endDateOfHandover: defaultDate,
            })
        } else {
            this.setState({
                setHandoverCondominiumGroup: setHandoverCondominiumGroup,
                handoverCondominiumGroupId: null,
                endDateOfHandover: null,
            })
        }
    }

    handleChangeHandoverCondominiumGroupId(
        handoverCondominiumGroupId: number,
        handoverCondominiumGroupName?: string): void {
        this.setState({
            handoverCondominiumGroupId: handoverCondominiumGroupId,
            handoverCondominiumGroupName: handoverCondominiumGroupName ? handoverCondominiumGroupName : '',
        })
    }

    handleChangeEndDateOfHandover(date: Nullable<Date>): void {
        if (date) {
            const endDateOfHandoverMoment = moment(date.toISOString())
            this.setState({
                endDateOfHandover: new Date(endDateOfHandoverMoment.endOf('month').format('YYYY-MM-DD')),
            })
        } else {
            this.setState({
                endDateOfHandover: null,
            })
        }
    }

    handleChangeLoginId(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({loginId: event.target.value})
    }

    handleChangeMailAddress(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({mailAddressValue: event.target.value, warning: [], warningChecked: false})
    }

    handleChangePassword(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({password: event.target.value})
    }

    handleChangePasswordConfirm(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({passwordConfirm: event.target.value})
    }

    onCompositionStartFamilyName(): void {
        this.setState({
            convertFamilyNameKana: '',
            preFamilyNameKana: this.state.familyNameKanaValue ?? '',
        })
    }

    onCompositionUpdateFamilyName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertFamilyNameKana: this.state.preFamilyNameKana + kana})
        })
    }

    onCompositionStartFirstName(): void {
        this.setState({
            convertFirstNameKana: '',
            preFirstNameKana: this.state.firstNameKanaValue ?? '',
        })
    }

    onCompositionUpdateFirstName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertFirstNameKana: this.state.preFirstNameKana + kana})
        })
    }

    onChangeFamilyName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            familyNameValue: event.target.value,
            familyNameKanaValue: event.target.value ? this.state.convertFamilyNameKana : '',
        })
    }

    onChangeFirstName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            firstNameValue: event.target.value,
            firstNameKanaValue: event.target.value ? this.state.convertFirstNameKana : '',
        })
    }

    onChangeFamilyNameKana(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({familyNameKanaValue: event.target.value})
    }

    onChangeFirstNameKana(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({firstNameKanaValue: event.target.value})
    }

    onChangeLoginAvailability(event: React.ChangeEvent<HTMLInputElement>): void {

        this.setState({loginAvailability: event.target.value})
    }

    // ログイン可否に表示するラベルをコード一覧から取得
    getLoginAvailabilityLabel(value: string): string {
        const loginAvailabilityCode = AVAILABLE_OR_NOT.codeToEnumConstants(value)
        if (loginAvailabilityCode) {
            return loginAvailabilityCode.label
        } else {
            return ''
        }
    }

    closeSelectCondominiumDiaLog(): void {
        this.setState({dialogOpenSelectCondominium: false})
    }

    closeSelectResidentUserDiaLog(): void {
        this.setState({dialogOpenSelectResidentUser: false})
    }

    getRoleMasterRadioGroupData(): PPRadioItemProp[] {
        return ROLE_FOR_ADMINISTRATOR.values()
            .filter(role => role.value !== ROLE_FOR_ADMINISTRATOR.ASSOC.value)
            .map((role) => {
                return {
                    label: role.label,
                    value: role.value,
                    radioProps: {
                        autoFocus: role.value === this.state.roleId,
                        checked: role.value === this.state.roleId,
                    },
                }
            })
    }

    handleOpenCondominiumSelectionDialog(): void {
        // 物件を選び直すたびに居住者ユーザをリセット
        this.setState({
            dialogOpenSelectCondominium: true,
            selectedResidentUserInfo: {
                sutekiNetId: '',
                seq: 0,
                ridgeCd: '',
                ridgeName: '',
                roomNumber: '',
                familyName: '',
                firstName: '',
                adminFamilyName: '',
                adminFirstName: '',
                parentAdminFamilyName: '',
                parentAdminFirstName: '',
                roleName: '',
                mailAddressPc: '',
                mailAddressMb: '',
                parentFamilyName: '',
                parentFirstName: '',
                status: '',
                updateDatetime: '',
                condominiumGroupName: '',
                condominiumCd: '',
                condominiumName: '',
            },
            selectedRoomToResidentInfos: [],
        })
    }

    async handleOpenResidentUserSelectionDialog(): Promise<void> {
        const currentDateTime: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
            this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
            (httpErrorOrNetworkError) => {
                this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        if (currentDateTime && currentDateTime.details) {
            this.setState({
                currentDate: moment(currentDateTime.details.currentDateTime),
            })
        }

        if (this.state.selectedCondominiumInfo.condominiumCd) {
            this.setState({
                dialogOpenSelectResidentUser: true,
            })
        }
    }

    setSelectedCondominiumInfo(selectedCondominiumInfo: CondominiumInfo): void {
        this.setState({
            selectedCondominiumInfo: selectedCondominiumInfo,
            dialogOpenSelectCondominium: false,
        })
    }

    async setSelectedResidentUserInfo(selectedResidentUserInfo: ResidentUserInfo): Promise<void> {

        if (selectedResidentUserInfo.sutekiNetId) {
            const flpAdminUserInfo: Nullable<NatGetOwnerCondominium> = await this.props.asyncCallFunction(
                this.props.OwnerCondominiumRepo.getOwnerCondomoinum.bind(
                    this.props.OwnerCondominiumRepo,
                    selectedResidentUserInfo.sutekiNetId,
                    selectedResidentUserInfo.condominiumCd,
                ),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )

            if (flpAdminUserInfo && flpAdminUserInfo.details) {
                const roomToresidents: string[] = []
                flpAdminUserInfo.details.roomToResident.map((userInfo) => {
                    roomToresidents.push(userInfo.ridgeName + ' ' +
                        userInfo.roomNumber)
                })
                this.setState({selectedResidentUsersRoomInfo: roomToresidents.join(',')})
                this.setState({selectedRoomToResidentInfos: flpAdminUserInfo.details.roomToResident})
            } else {
                return
            }
        } else {
            this.setState({
                selectedResidentUsersRoomInfo:
                    selectedResidentUserInfo.ridgeName + ' ' + selectedResidentUserInfo.roomNumber,
            })
            const invalidResident: RoomToResident[] = [{
                ridgeCd: selectedResidentUserInfo.ridgeCd,
                ridgeName: selectedResidentUserInfo.ridgeName,
                roomNumber: selectedResidentUserInfo.roomNumber,
                adminFamilyName: selectedResidentUserInfo.adminFamilyName ? selectedResidentUserInfo.adminFamilyName : '',
                adminFirstName: selectedResidentUserInfo.adminFirstName ? selectedResidentUserInfo.adminFirstName : '',
                parentAdminFamilyName: selectedResidentUserInfo.parentAdminFamilyName ?
                    selectedResidentUserInfo.parentAdminFamilyName : '',
                parentAdminFirstName: selectedResidentUserInfo.parentAdminFirstName ?
                    selectedResidentUserInfo.parentAdminFirstName : '',
            }]
            this.setState({selectedRoomToResidentInfos: invalidResident})
        }

        this.setState({
            selectedResidentUserInfo: selectedResidentUserInfo,
            dialogOpenSelectResidentUser: false,
        })
    }

    renderSelectedCondominiumInfo(condominiumCd: string, condominiumName: string): ReactNode {

        if (!condominiumCd || !condominiumName) {
            return (<></>)
        } else {
            return (
                <>
                    <SelectedFlexWrapperWide>
                        <SelectedModalInfoItemLabel>物件コード</SelectedModalInfoItemLabel>
                        <SelectedModalInfoItemValue>{condominiumCd}</SelectedModalInfoItemValue>
                    </SelectedFlexWrapperWide>
                    <SelectedFlexWrapperLong>
                        <SelectedModalInfoItemLabel>物件名</SelectedModalInfoItemLabel>
                        <SelectedModalInfoItemValueCondominium>{condominiumName}</SelectedModalInfoItemValueCondominium>
                    </SelectedFlexWrapperLong>
                </>
            )
        }
    }

    renderSelectedResidentUserInfo(ownerCondominiumInfos: RoomToResident[]): ReactNode {
        if (ownerCondominiumInfos.length === 0) {
            return (<></>)
        }
        const roomInfos: string[] = []
        const adminName: string[] = []
        ownerCondominiumInfos.map((ownerCondominiumInfo) => {
            roomInfos.push((ownerCondominiumInfo.ridgeName ? ownerCondominiumInfo.ridgeName : '') + ' ' +
                (ownerCondominiumInfo.roomNumber ? ownerCondominiumInfo.roomNumber : ''))
            if (ownerCondominiumInfo.parentAdminFamilyName !== null) {
                adminName.push((ownerCondominiumInfo.parentAdminFamilyName ?
                        ownerCondominiumInfo.parentAdminFamilyName : '') + ' ' +
                    (ownerCondominiumInfo.parentAdminFirstName ?
                        ownerCondominiumInfo.parentAdminFirstName : ''))
            } else {
                adminName.push((ownerCondominiumInfo.adminFamilyName ?
                        ownerCondominiumInfo.adminFamilyName : '') + ' ' +
                    (ownerCondominiumInfo.adminFirstName ?
                        ownerCondominiumInfo.adminFirstName : ''))
            }
        })

        return (
            <>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>部屋番号</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValue>{roomInfos.join(',')}</SelectedModalInfoItemValue>
                </SelectedFlexWrapperWide>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>氏名</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValueCondominium>
                        {(this.state.selectedResidentUserInfo.familyName ||
                            this.state.selectedResidentUserInfo.firstName) ?
                            this.state.selectedResidentUserInfo.familyName + ' ' +
                            this.state.selectedResidentUserInfo.firstName : ''
                        }
                    </SelectedModalInfoItemValueCondominium>
                </SelectedFlexWrapperWide>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>管理者確認用氏名</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValueCondominium>
                        {adminName.join(',')}</SelectedModalInfoItemValueCondominium>
                </SelectedFlexWrapperWide>
            </>
        )
    }

    renderInputFormTable(): ReactNode {
        const passwordRequired = this.state.roleId === ROLE_FOR_ADMINISTRATOR.LIFE_MANAGER.value ||
            this.state.roleId === ROLE_FOR_ADMINISTRATOR.CONCIERGE.value ||
            this.state.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value

        return (
            <>
                <ConditionTableFixed>
                    <colgroup>
                        <col width={'25%'}/>
                        <col width={'10%'}/>
                        <col width={'25%'}/>
                        <col width={'10%'}/>
                        <col width={'30%'}/>
                    </colgroup>
                    <StyledTableCaption>管理者ユーザ情報</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName required>権限</TableRowName>
                            <TableCell colSpan={4}>
                                <PPRadioGroup
                                    row
                                    data={this.getRoleMasterRadioGroupData()}
                                    eventKeys={['roleId']}
                                    onChange={this.onChangeRole.bind(this)}
                                    defaultValue={this.state.roleId}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>物件グループを選択</TableRowName>
                            <TableCell colSpan={4}>
                                {
                                    this.state.condominiumGroup &&
                                    this.state.condominiumGroup.details &&
                                    <NatCondominiumGroupSelectComponent
                                        condominiumGroup={this.state.condominiumGroup.details}
                                        defaultValue={this.state.loginUserCondominiumGroupId}
                                        onChangeSelectedCondominiumGroupId={this.onChangeSelectedCondominiumGroupId}
                                        requiredFlag={true}
                                        eventKeys={['condominiumGroupId']}
                                        eventEmitter={this.props.eventEmitter}
                                    >
                                    </NatCondominiumGroupSelectComponent>
                                }
                            </TableCell>
                        </TableRow>
                        {(() => {
                            if (this.state.roleId === ROLE_FOR_ADMINISTRATOR.LIFE_MANAGER.value ||
                                this.state.roleId === ROLE_FOR_ADMINISTRATOR.CONCIERGE.value ||
                                this.state.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value
                            ) {
                                return (
                                    <TableRow>
                                        <TableRowName required>物件を選択</TableRowName>
                                        <TableCell colSpan={4}>
                                            <RowFlexContainer>
                                                <SelectedFlexWrapper>
                                                    <PPErrorDisplayButton
                                                        component={'span'}
                                                        disabled={false}
                                                        size={'small'}
                                                        eventEmitter={this.props.eventEmitter}
                                                        eventKeys={['condominiumCd']}
                                                        onClick={this.handleOpenCondominiumSelectionDialog}
                                                        clearError={true}
                                                    >
                                                        選択する
                                                    </PPErrorDisplayButton>
                                                </SelectedFlexWrapper>
                                                {this.renderSelectedCondominiumInfo(
                                                    this.state.selectedCondominiumInfo.condominiumCd,
                                                    this.state.selectedCondominiumInfo.condominiumName,
                                                )}
                                            </RowFlexContainer>
                                        </TableCell>
                                    </TableRow>
                                )
                            }
                        })()}
                        {this.state.dialogOpenSelectCondominium && this.state.condominiumGroup.details &&
                            <NatCondominiumSelectionComponent
                                selectedCondominiumGroupId={this.state.selectedCondominiumGroupId}
                                selectCondominiumType={SELECT_CONDOMINIUM_TYPE.CONDOMINIUM.value}
                                condominiumRepo={this.props.CondominiumRepo}
                                condominiumGroupRepo={this.props.CondominiumGroupRepo}
                                closeSelectCondominiumDiaLog={this.closeSelectCondominiumDiaLog}
                                setSelectedCondominiumInfo={this.setSelectedCondominiumInfo}
                                eventEmitter={this.props.eventEmitter}
                                navigate={this.props.navigate}
                                location={this.props.location}
                                asyncCallFunction={this.props.asyncCallFunction}
                            />
                        }
                        {this.state.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value &&
                            <TableRow>
                                <TableRowName required>居住者ユーザを選択</TableRowName>
                                <TableCell colSpan={4}>
                                    <RowFlexContainer>
                                        <SelectedFlexWrapper>
                                            <PPErrorDisplayButton
                                                component={'span'}
                                                disabled={
                                                    !this.state.selectedCondominiumInfo.condominiumCd ? true : false
                                                }
                                                size={'small'}
                                                eventEmitter={this.props.eventEmitter}
                                                eventKeys={['sutekiNetId']}
                                                onClick={this.handleOpenResidentUserSelectionDialog}
                                                clearError={true}
                                            >
                                                選択する
                                            </PPErrorDisplayButton>
                                        </SelectedFlexWrapper>
                                        {this.renderSelectedResidentUserInfo(this.state.selectedRoomToResidentInfos)}
                                    </RowFlexContainer>
                                </TableCell>
                            </TableRow>
                        }
                        {this.state.dialogOpenSelectResidentUser &&
                            <NatResidentUserSelectionComponent
                                roomToResidentRepo={this.props.RoomToResidentRepo}
                                ridgeRepo={this.props.RidgeRepo}
                                selectUserType={SELECT_USER_TYPE.USER.value}
                                closeSelectResidentUserDiaLog={this.closeSelectResidentUserDiaLog}
                                setSelectedResidentUserInfo={this.setSelectedResidentUserInfo}
                                selectedCondominiumCd={this.state.selectedCondominiumInfo.condominiumCd}
                                invalidUserSelectFlag={true}
                                validPeriodCriteriaDate={this.state.currentDate}
                                eventEmitter={this.props.eventEmitter}
                                navigate={this.props.navigate}
                                location={this.props.location}
                                asyncCallFunction={this.props.asyncCallFunction}
                            />
                        }
                        {this.state.roleId === ROLE_FOR_ADMINISTRATOR.FRONT_STAFF.value &&
                            <TableRow>
                                <TableRowName required>引継情報を設定</TableRowName>
                                <TableCell colSpan={4}>
                                    <StyledColumnFlexContainer>
                                        <PPRadioGroup
                                            row
                                            data={[{
                                                label: DO_OR_NOT.NOT.label,
                                                value: DO_OR_NOT.NOT.value,
                                                radioProps: {
                                                    autoFocus: DO_OR_NOT.NOT.value
                                                        === this.state.setHandoverCondominiumGroup,
                                                    checked: DO_OR_NOT.NOT.value
                                                        === this.state.setHandoverCondominiumGroup,
                                                },
                                            },
                                                {
                                                    label: DO_OR_NOT.DO.label,
                                                    value: DO_OR_NOT.DO.value,
                                                    radioProps: {
                                                        autoFocus: DO_OR_NOT.DO.value
                                                            === this.state.setHandoverCondominiumGroup,
                                                        checked: DO_OR_NOT.DO.value
                                                            === this.state.setHandoverCondominiumGroup,
                                                    },
                                                }]}
                                            eventKeys={['setHandoverCondominiumGroup']}
                                            onChange={this.handleChangeSetHandoverCondominiumGroup}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                        {this.state.setHandoverCondominiumGroup === DO_OR_NOT.DO.value &&
                                            <>
                                                <label>
                                                    <StyledRowFlexContainer>
                                                        <StyledDivNoWrap>引継中物件グループ</StyledDivNoWrap>
                                                        {
                                                            this.state.condominiumGroup &&
                                                            this.state.condominiumGroup.details &&
                                                            <StyledFlexItem>
                                                                <NatCondominiumGroupSelectComponent
                                                                    condominiumGroup={
                                                                        this.state.condominiumGroup.details}
                                                                    defaultValue={this.state.handoverCondominiumGroupId
                                                                        ? this.state.handoverCondominiumGroupId
                                                                        : this.state.loginUserCondominiumGroupId}
                                                                    onChangeSelectedCondominiumGroupId={
                                                                        this.handleChangeHandoverCondominiumGroupId}
                                                                    requiredFlag={true}
                                                                    eventKeys={['handoverCondominiumGroupId']}
                                                                    eventEmitter={this.props.eventEmitter}
                                                                >
                                                                </NatCondominiumGroupSelectComponent>
                                                            </StyledFlexItem>
                                                        }
                                                    </StyledRowFlexContainer>
                                                </label>
                                                <label>
                                                    <StyledRowFlexContainer>
                                                        <StyledDivNoWrap>引継期間</StyledDivNoWrap>
                                                        <Box pl={'80px'}>
                                                            <PPDatePicker
                                                                inputType={'ym_jp'}
                                                                onChangeDate={
                                                                    this.handleChangeEndDateOfHandover}
                                                                value={(this.state.endDateOfHandover)
                                                                    ? new Date(this.state.endDateOfHandover)
                                                                    : null
                                                                }
                                                                minDate={new Date(this.state.currentDate!.format(
                                                                    'YYYY-MM-DD'))}
                                                                eventEmitter={this.props.eventEmitter}
                                                                eventKeys={['endDateOfHandover']}
                                                            />
                                                        </Box>
                                                        末まで
                                                    </StyledRowFlexContainer>
                                                </label>
                                            </>
                                        }
                                    </StyledColumnFlexContainer>
                                </TableCell>
                            </TableRow>
                        }
                        <TableRow>
                            <TableRowName required>管理者ID</TableRowName>
                            <TableCell colSpan={this.state.roleId === ROLE_FOR_ADMINISTRATOR.FRONT_STAFF.value ? 2 : 4}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 10,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.loginId}
                                    onChange={this.handleChangeLoginId}
                                    eventKeys={['loginId', 'adminId']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                            {this.state.roleId === ROLE_FOR_ADMINISTRATOR.FRONT_STAFF.value &&
                                <TableCell colSpan={2}>
                                    <AdminPrimaryButton
                                        onClick={this.getAzureADUser}
                                    >
                                        社員番号からユーザ情報入力
                                    </AdminPrimaryButton>
                                </TableCell>
                            }
                        </TableRow>
                        {this.state.roleId !== ROLE_FOR_ADMINISTRATOR.ASSOC.value &&
                        <TableRow>
                            <TableRowName>メールアドレス</TableRowName>
                            <TableCell colSpan={4}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 100,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.mailAddressValue}
                                    onChange={this.handleChangeMailAddress}
                                    eventKeys={['mailAddress']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        }
                        <StyledTableRow
                            hidden={this.state.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value}>
                            <TableRowName required>氏名</TableRowName>
                            <TableCell>姓</TableCell>
                            <TableCell>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            name: 'familyName',
                                            id: 'familyName',
                                            maxLength: 10,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.familyNameValue}
                                    onInput={this.onChangeFamilyName}
                                    onChange={this.onChangeFamilyName}
                                    onCompositionStart={this.onCompositionStartFamilyName}
                                    onCompositionUpdate={this.onCompositionUpdateFamilyName}
                                    eventKeys={['familyName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                            <TableCell>名</TableCell>
                            <TableCell>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            name: 'firstName',
                                            id: 'firstName',
                                            maxLength: 10,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.firstNameValue}
                                    onInput={this.onChangeFirstName}
                                    onChange={this.onChangeFirstName}
                                    onCompositionStart={this.onCompositionStartFirstName}
                                    onCompositionUpdate={this.onCompositionUpdateFirstName}
                                    eventKeys={['firstName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </StyledTableRow>
                        <StyledTableRow
                            hidden={this.state.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value}>
                            <TableRowName>氏名(フリガナ)</TableRowName>
                            <TableCell>セイ</TableCell>
                            <TableCell>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            name: 'familyNameKana',
                                            id: 'familyNameKana',
                                            maxLength: 20,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.familyNameKanaValue}
                                    onInput={this.onChangeFamilyNameKana}
                                    onChange={this.onChangeFamilyNameKana}
                                    eventKeys={['familyNameKana']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                            <TableCell>メイ</TableCell>
                            <TableCell>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            name: 'firstNameKana',
                                            id: 'firstNameKana',
                                            maxLength: 20,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.firstNameKanaValue}
                                    onInput={this.onChangeFirstNameKana}
                                    onChange={this.onChangeFirstNameKana}
                                    eventKeys={['firstNameKana']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </StyledTableRow>
                        <TableRow>
                            <TableRowName required={passwordRequired}>パスワード</TableRowName>
                            <TableCell colSpan={4}>
                                <PPInput
                                    type="password"
                                    inputProps={{
                                        maxLength: 20,
                                    }}
                                    autoComplete={'new-password'}
                                    required
                                    fullWidth
                                    value={this.state.password}
                                    onChange={this.handleChangePassword}
                                    hint={Messages.HCONA0008.toString()}
                                    eventKeys={['password']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required={passwordRequired}>パスワード（確認用）</TableRowName>
                            <TableCell colSpan={4}>
                                <PPInput
                                    type="password"
                                    inputProps={{
                                        maxLength: 20,
                                    }}
                                    autoComplete={'new-password'}
                                    required
                                    fullWidth
                                    value={this.state.passwordConfirm}
                                    onChange={this.handleChangePasswordConfirm}
                                    eventKeys={['passwordConfirm']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>任期開始日</TableRowName>
                            <TableCell colSpan={2} style={{paddingBottom: 18, paddingTop: 22}}>
                                <PPDatePicker
                                    onChangeDate={this.onChangeTermStartDate}
                                    value={(this.state.termStartDate) ?
                                        new Date(this.state.termStartDate) : null
                                    }
                                    eventEmitter={this.props.eventEmitter}
                                    eventKeys={['termStartDate']}
                                    maxDate={(this.state.termEndDate !== '') ?
                                        new Date(this.state.termEndDate) : undefined
                                    }
                                />
                            </TableCell>
                            <TableRowName>任期終了日</TableRowName>
                            <TableCell colSpan={2} style={{paddingBottom: 18, paddingTop: 22}}>
                                <PPDatePicker
                                    onChangeDate={this.onChangeTermEndDate}
                                    value={(this.state.termEndDate) ?
                                        new Date(this.state.termEndDate) : null
                                    }
                                    eventEmitter={this.props.eventEmitter}
                                    eventKeys={['termEndDate']}
                                    minDate={(this.state.termStartDate !== '') ?
                                        new Date(this.state.termStartDate) : undefined
                                    }
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>ログイン可否</TableRowName>
                            <TableCell colSpan={4}>
                                <PPRadioGroup
                                    row
                                    data={AVAILABLE_OR_NOT.values()}
                                    onChange={this.onChangeLoginAvailability}
                                    eventKeys={['loginAvailability']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </ConditionTableFixed>
            </>
        )
    }

    onChangeTermStartDate(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({
                minTermEndDate: formatForDateInput(date.toString()),
                termStartDate: formatForDateInput(date.toString()),
            })
        } else {
            this.setState({
                minTermEndDate: '',
                termStartDate: '',
            })
        }
    }

    onChangeTermEndDate(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({
                maxTermStartDate: formatForDateInput(date.toString()),
                termEndDate: formatForDateInput(date.toString()),
            })
        } else {
            this.setState({
                maxTermStartDate: '',
                termEndDate: '',
            })
        }
    }

    changeAcceptedWarnings(acceptAll: boolean): void {
        this.setState({
            warningChecked: acceptAll,
        })
    }

    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={this.judgementDispPostAdminUserButton()}
                        onClick={this.registerAdminUserButton.bind(this)}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={() => this.props.navigate(
                            '/admin/adminUserList',
                            {state: {searchCondition: this.state.adminUserListSearchCondition}},
                        )}
                    >
                        管理者ユーザ検索へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }


    render(): ReactElement {
        if (!this.state.isLoadCompleted) {
            return (<></>)
        }
        return (
            <>
                <PageMainArea>
                    <form>
                        {this.renderInputFormTable()}
                    </form>
                </PageMainArea>
                <Box height={16}/>
                <NatAdminCommonAcceptedWarningComponent
                    title={'ご確認ください'}
                    description={'メールアドレスが入力されていません。'}
                    warnings={this.state.warning}
                    changeAcceptedWarnings={this.changeAcceptedWarnings}
                    doOpenAnimation={true}/>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>

        )
    }
}

export const SelectedModalInfoItemLabel: StyledSpan = styled.span`
  font-size: smaller;
  white-space: nowrap;
  margin-left: 20px;
  margin-right: 20px;
`

export const SelectedModalInfoItemValue: StyledSpan = styled.span`
  font-weight: bolder;
  white-space: normal;
  margin-right: 20px;
`

export const SelectedModalInfoItemValueCondominium = styled(SelectedModalInfoItemValue)`
  margin-right: 0;
  white-space: normal;
  word-break: break-all;
`

const SelectedFlexWrapper = styled.div`
  display: flex;
  padding-right: 15px;
  flex: 1 1 0%;
  align-items: center;
`

const SelectedFlexWrapperWide = styled(SelectedFlexWrapper)`
  flex-grow: 2;
`

const SelectedFlexWrapperLong = styled(SelectedFlexWrapper)`
  flex-grow: 5;

`

const StyledTableRow = styled(TableRow)<{ hidden?: boolean }>`
  &.MuiTableRow-root {
    visibility: ${props => props.hidden ? 'collapse' : 'visible'};
  }
`

const StyledColumnFlexContainer: StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`

const StyledRowFlexContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  width: 100%;
`

const StyledFlexItem = styled.div`
  width: 100%;
  padding-left: 10px;
`

const StyledDivNoWrap = styled.div`
  white-space: nowrap;
`

export default createAdminPage(NatAdminAdminUserRegisterPage)

